/** Mirrors si.medifit.* BpiType (integration / contractor BPI channel). */
export enum BpiType {
    AUDAX = 'AUDAX',
    X21 = 'X21',
    LIST = 'LIST',
    MEDIFIT = 'MEDIFIT',
    SEPARATED = 'SEPARATED',
    PAPP = 'PAPP',
    HELIANT = 'HELIANT',
    NOVA_VIZIJA = 'NOVA_VIZIJA',
    ENDAVA = 'ENDAVA',
}
